// import React from "react";
// import { Navigate } from "react-router-dom";
// import Cookies from "js-cookie";

// export default function PrivateRoute(props) {

//     return (
//         <>
//             {(Cookies.get('mhet_mst_token')) ?
//                 props.children
//                 :
//                 <Navigate to={`/${Cookies.get('mhet_mst_project')}/`} />
//             }
//         </>
//     )
// };

import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { preferenceReportAllowedUsers, searchCandidateAllowedUsers } from "../utils/constants";
import { saveReturnUrl } from "../utils/returnUrl";
import {
  getTokenRoles,
  isDataVerifierOnly,
  isAdmitCardVerifierOnly,
  ADMIT_CARD_VERIFIER_ROLE,
} from "../utils/roles";

export default function PrivateRoute({ children }) {
  const token = Cookies.get("mhet_mst_token");
  const project = Cookies.get("mhet_mst_project");
  const userId = String(Cookies.get("mhet_mst_userid"));
  const location = useLocation();

  // ❌ Not logged in
  if (!token) {
    // Preserve the intended destination (e.g. the QR ?data= param) so the user
    // is returned here after logging in.
    saveReturnUrl(`${location.pathname}${location.search}`);
    return <Navigate to={`/${project}/`} replace />;
  }

  // 🔒 Data Verifier sessions may only use candidate verification.
  if (
    isDataVerifierOnly(getTokenRoles(token)) &&
    !location.pathname.endsWith("/candidate-verification")
  ) {
    return <Navigate to={`/${project}/candidate-verification`} replace />;
  }

  // 🔒 Admit Card Verifier sessions may only use admit card verification
  // (this also takes them there after login, which lands on /home).
  if (
    isAdmitCardVerifierOnly(getTokenRoles(token)) &&
    !location.pathname.endsWith("/admit-card-verification")
  ) {
    return <Navigate to={`/${project}/admit-card-verification`} replace />;
  }

  // ...and the page is theirs alone: other roles are refused by its APIs, so
  // send them home rather than show a screen that cannot work.
  if (
    location.pathname.endsWith("/admit-card-verification") &&
    !getTokenRoles(token).includes(ADMIT_CARD_VERIFIER_ROLE)
  ) {
    return <Navigate to={`/${project}/home`} replace />;
  }

  const isPreferenceUser = preferenceReportAllowedUsers.includes(userId);
  const isSearchCandidateUser = searchCandidateAllowedUsers.includes(userId);

  const isPreferenceReportRoute =
    location.pathname === `/${project}/course-wise-preference-report` ||
    location.pathname === `/${project}/preference-wise-report`;

  const isSearchCandidateRoute = location.pathname === `/${project}/search-candidate`;

  const isHomeRoute = location.pathname === `/${project}/home`;

  // 🚀 Preference users should NOT stay on home
  if (isPreferenceUser && isHomeRoute) {
    return (
      <Navigate
        to={`/${project}/course-wise-preference-report`}
        replace
      />
    );
  }

  // 🚀 Search Candidate users should NOT stay on home
  if (isSearchCandidateUser && isHomeRoute) {
    return (
      <Navigate
        to={`/${project}/search-candidate`}
        replace
      />
    );
  }

  // 🚫 Non-preference users trying to access preference routes
//   if (!isPreferenceUser && isPreferenceReportRoute) {
//     return <Navigate to={`/${project}/home`} replace />;
//   }

  // ✅ Allowed
  return children;
}